import React from 'react';
import {
  hasTodoChecklist,
  parseTodoChecklistLines,
  TODO_CHECK_OFF,
  TODO_CHECK_ON,
} from '../../utils/todoChecklist';

/** 체크 상태 표시 전용 박스 (클릭 전환은 수정 모달 입력창에서만) */
export const TodoCheckBoxGlyph: React.FC<{ checked: boolean }> = ({ checked }) => (
  <span className={'cp-todo-check' + (checked ? ' is-checked' : '')} aria-hidden>
    {checked ? (
      <svg viewBox="0 0 16 16" width="100%" height="100%">
        <path
          d="M4 8.4l2.6 2.6L12 5.4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ) : null}
  </span>
);

/**
 * TODO 메모 텍스트 표시 — ☐/☑ 로 시작하는 줄을 체크박스 그림으로.
 * 부모의 white-space: pre-wrap 을 그대로 쓰도록 줄 사이는 '\n' 텍스트로 잇는다.
 * mirror: 입력창 뒤에 겹치는 층 — 원래 글자 폭을 그대로 유지(투명 문자 위에 그림)해 커서 위치가 어긋나지 않게 한다.
 */
const TodoChecklistText: React.FC<{ text: string; mirror?: boolean }> = ({ text, mirror = false }) => {
  if (!hasTodoChecklist(text)) return <>{text}</>;
  const lines = parseTodoChecklistLines(text);
  return (
    <>
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {i > 0 ? '\n' : null}
          {line.kind === 'text' ? (
            line.text
          ) : mirror ? (
            <span className={'cp-todo-check-line' + (line.checked ? ' is-checked' : '')}>
              {line.indent}
              <span className="cp-todo-check-anchor">
                <span className="cp-todo-check-anchor-char">
                  {line.checked ? TODO_CHECK_ON : TODO_CHECK_OFF}
                </span>
                <TodoCheckBoxGlyph checked={line.checked} />
              </span>
              {line.spaced ? ' ' : null}
              <span className="cp-todo-check-line-text">{line.text}</span>
            </span>
          ) : (
            <span
              className={'cp-todo-check-line' + (line.checked ? ' is-checked' : '')}
              aria-label={`${line.checked ? '완료' : '미완료'}: ${line.text}`}
            >
              {line.indent}
              <TodoCheckBoxGlyph checked={line.checked} />
              <span className="cp-todo-check-line-text">{line.text}</span>
            </span>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default TodoChecklistText;
